export function usePostHog() {
  const { $posthog } = useNuxtApp()

  if ($posthog) {
    return $posthog()
  } else {
    return undefined
  }
}
